import { render, staticRenderFns } from "./StoreFirstInfo.vue?vue&type=template&id=87700888&scoped=true&"
import script from "./StoreFirstInfo.vue?vue&type=script&lang=js&"
export * from "./StoreFirstInfo.vue?vue&type=script&lang=js&"
import style0 from "./StoreFirstInfo.vue?vue&type=style&index=0&id=87700888&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87700888",
  null
  
)

export default component.exports